<div class="col icon-with-ellipse-container">
  <mat-icon class="small-ellipse" [ngClass]="ellipseClass" mat-list-icon svgIcon="small-ellipse">
  </mat-icon>
  <i class="icon-with-ellipse-icon-main" [ngClass]="iconClass" [inlineSVG]="iconPath"></i>
  <mat-icon svgIcon="small-dot" class="icon-with-ellipse-small-dot" *ngIf="dotClass" [ngClass]="dotClass"></mat-icon>
  <i class="icon-with-ellipse-icon-secondary" *ngIf="secondaryIconPath" [ngClass]="iconClass" [inlineSVG]="secondaryIconPath"></i>
</div>
